export const invalidCompany = {
  title: 'Неверная компания',
  description: 'Пожалуйста, проверь компанию или напиши админу',
  button: 'Домой',
};
